import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ListCoverageResponse, RowMarkupOverride } from 'src/app/modules/espp/quotes/components/quote-details/plan-options/models/list-coverage-response.model';
import { DealerMarkUp, PlanOptionsFilterValue } from 'src/app/modules/espp/quotes/components/quote-details/plan-options/models/plan-option.model';
import { toListCoverageRequest } from 'src/app/modules/espp/quotes/components/quote-details/plan-options/plan-options.util';
import { coverageList } from 'src/app/shared/api.constants';

@Injectable({
  providedIn: 'root'
})
export class QuoteCoverageService {

  constructor(private http: HttpClient) { }

  /** Initial priced coverage/term/hours options for the multi-term Plan Options layout (WPAD-6518); also returns the default `selected_filters`. Errors propagate to the caller, which surfaces them. */
  public listCoverage(quoteId: number): Observable<ListCoverageResponse> {
    return this.http.get<ListCoverageResponse>(coverageList(quoteId));
  }

  /** Same endpoint as `listCoverage`, filtered server-side by `filter` (used once the user edits the filters). */
  public filterCoverage(quoteId: number, filter: PlanOptionsFilterValue, markup: DealerMarkUp | null = null, overrides: RowMarkupOverride[] = []): Observable<ListCoverageResponse> {
    return this.http.post<ListCoverageResponse>(coverageList(quoteId), toListCoverageRequest(filter, markup, overrides));
  }

  public updateCoverage(quoteID: number,coverageID: number){
    return this.http.delete(`api/v1/quotes/${quoteID}/coverages/${coverageID}`)
}

  public delete(quoteID: number,coverageID: number){
      return this.http.delete(`api/v1/quotes/${quoteID}/coverages/${coverageID}`)
  }

  //,equipment: { serial_number: string | any, pin17: string |  any,reatial_value: number | any}
  public updateApplicationCoverageData(quoteID: number, data: {sale_date: string | null, comments: string | null | undefined}){
    return this.http.post(`api/v1/espp/quotes/${quoteID}/application_update?simple_response=true`,data)
  }
}
